import React, { useState, forwardRef, useImperativeHandle } from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: 'black',
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6" style={{ fontWeight: 'bold' }}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogoShowVenda = forwardRef((props, ref) => {
  const [open, setOpen] = useState(false);
  const [titulo, setTitulo] = useState('');
  const [dados, setDados] = useState('');
  const [nfceCriada, setNfceCriada] = useState('');

  function handleClose() {
    setOpen(false);
  }

  useImperativeHandle(ref, () => ({
    handleOpen(titulo, dados, nfceCriada) {
      setOpen(true);
      setDados(dados);
      setTitulo(titulo);
      setNfceCriada(nfceCriada);
    },
  }));

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
      disableBackdropClick
      disableEscapeKeyDown
      fullScreen
    >
      <DialogTitle id="form-dialog-title" onClose={handleClose}>
        {titulo}
      </DialogTitle>
      <DialogContent dividers>
        <h2>Retorno Sefaz</h2>
        <pre style={{ height: '100%', backgroundColor: 'white' }}>{dados}</pre>
        <h2>Nfce Montada Pelo Sistema</h2>
        <pre style={{ height: '100%', backgroundColor: 'white' }}>
          {nfceCriada}
        </pre>
      </DialogContent>
    </Dialog>
  );
});

export default DialogoShowVenda;
